<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">PNL Account Balance
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="7">
                  <b-input-group >
                        <b-input-group-prepend><label>Date Range</label></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" ></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="5">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row >
            <b-row >
                <b-col lg="10" >
                  <b-input-group >
                        <b-input-group-prepend><label>Dept/Div/Dir</label></b-input-group-prepend>
                        <b-form-radio-group  class="mt-2" v-model="filter.opsiDept" name="radioDept" :state="!$v.filter.opsiDept.$error">
                            <b-form-radio value="1">All</b-form-radio>
                            <b-form-radio value="2">Empty (Non Dept)</b-form-radio>
                            <b-form-radio value="3">Choice</b-form-radio>
                        </b-form-radio-group>
                        <b-form-select v-model="filter.DimCol" :state="!$v.filter.DimCol.$error" :plain="true" :options="['Department','Division','Directorat']" :disabled="(filter.opsiDept!=3)"></b-form-select>
                        <b-form-input v-model="filter.departemen" :state="!$v.filter.departkd.$error" placeholder="Value" class="ml-1" disabled style="width:27%"></b-form-input>
                        <b-input-group-append v-if="(filter.opsiDept==3)">
                            <b-btn text="Button" @click="lkuDeptShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="2" >
                    <b-button class="btn btn-success" @click="process()">Process</b-button>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th style="width:100px;">Kode</th>
                            <th >Description</th>
                            <th style="text-align:right"  v-for="kol in rptPnl.koloms" :key="kol.namakolom">{{kol.kode}} | {{kol.nama}}</th>
                            <th style="text-align:right" >Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptPnl.lines" :key="row.idrowunik">
                            <td :class="row.kelas">{{row.kode}}</td>
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas" v-for="kol in rptPnl.koloms" :key="`${row.kode}-${kol.namakolom}`" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonToDate(row,row[kol.namakolom],kol)">{{row[kol.namakolom] | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">
                                {{row.total | numFormat}}
                            </td>
                            <td v-else ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuDeptShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDept"></lku-department>
        </b-modal>        

    </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import budget_dept from "../../apis/budget_dept";
import toastr from "mini-toastr";
import moment from 'moment';
import lkuDepartment from "../lookup/lkuDepartment";
import { validationMixin } from "vuelidate";
import { required,requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        opsiDept: { required },
        DimCol: { required },
        departkd: {
                required: requiredIf(function () {
                    return this.filter.opsiDept==3
                })
            },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      lkuDeptShow:false,
      isLoading: false,
      layouts:[{value: 'AUTOPNLACCOUNT', text: 'ALL PNL ACCOUNT'}],
      filter: {layout:'AUTOPNLACCOUNT', opsiDept:3, DimCol:'Department', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY'), bulan:moment(this.$store.state.user.tglaktif).format('MMM')},
      monthLabels:["January","February","March","April","May","Juni","July","August","September","October","November","December"],
      horizontal: true,
      reportUrl: `${location.origin}/#load`,
      showReport:false,
      rptPnl:{lines:[], koloms:[]}
    };
  },
  components: { Loading,lkuDepartment },  

computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
          this.rptPnl.lines= await budget_dept.layout({layout : newval});
      }
  },
created: async function (){
    const ll  = await budget_dept.layout_combo();
    this.layouts= this.layouts.concat(ll);

    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');

    //  let bln = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').month();
    //  let awal= parseInt(this.$store.state.user.awalbln || '1')-1;
    //  if ((bln-awal) > 10) {
    //      this.enableNextYear=true;
    //  }
    this.rptPnl.lines= await budget_dept.layout(this.filter);

  },
methods:{
    updateTgl1: function() {
        // var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        // var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        // this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        // this.filter.tahun=tgl1.format('YYYY');
        // this.filter.bulan=tgl2.format('MMM');
        // this.filter.bln=tgl2.month();
        console.log(this.filter.tgl1)
    },
    onSelectLkuDept: async function (_selected) {
        this.lkuDeptShow=false;
        if (this.filter.DimCol=='Department') {
            this.filter.departemen = _selected.departkd.trim() + ' | ' + _selected.departemen.trim();
            this.filter.departid = _selected.departid;
            this.filter.departkd = _selected.departkd;
        } else  if (this.filter.DimCol=='Division') {
            this.filter.departemen = _selected.division;
            this.filter.departid = _selected.division;
            this.filter.departkd = _selected.division;
        } else {
            this.filter.departemen = _selected.directorate;
            this.filter.departid = _selected.directorate;
            this.filter.departkd = _selected.directorate;
        }
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.filter.bln = moment(this.filter.tgl2, 'YYYY-MM-DD').month();
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                model.modeGet='view'
                let arrRes = await budget_dept.fpbudgetv2(model);
                this.rptPnl.lines=arrRes[0];
                this.rptPnl.koloms=arrRes[1];

                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.filter.bln = moment(this.filter.tgl2, 'YYYY-MM-DD').month();
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                model.modeGet='xls'
                const response = await budget_dept.fpbudgetv2(model);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Financial_position_12Months_${model.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },
    drillMonToDate: function(data,nilai, kolom)
    {
        console.log('data : ', data);
        console.log('nilai : ', nilai);
        console.log('kolom : ', kolom);

        // if ((data.kode) && (nilai)) {
        if (data.kode)  {
                this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, Department "${kolom.kode} | ${kolom.nama}" ?`, {
                title: 'Drilldown Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(value => {
                    if (value==true) {
                        const tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                        const tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');

                        const routeData = router.resolve({path: `ledger/${data.kode}/${tgl1}/${tgl2}/${data.uraian}/${kolom.kode}/${kolom.nama}`});
                        window.open(routeData.href, '_blank');
                    }
                })
                .catch(err => {
                    console.log('msgBoxConfirm error', err);
                })


        }
    },
    close(){
      router.push("home");
    }
  }
};
</script>
